import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import "../../../gallery/gallery/gallery.scss?vue&type=style&index=0&id=6c0c950e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0c950e"]])

export default __exports__